export default function generateCSSSupportRule(support, cssRules) {
  return "@supports ".concat(support, "{").concat(cssRules, "}");
}